class RttysAuth {
  constructor (baseUrl = '', cookieName = 'sid') { // 默认改为 sid
    this.baseUrl = baseUrl.replace(/\/$/, '')
    this.cookieName = cookieName
  }

  async login (password) {
    const resp = await fetch(`${this.baseUrl}/signin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
      credentials: 'include'
    })
    if (!resp.ok) throw new Error('Login failed')
    // 登录成功通常可直接返回 true，或再验证一次
    return this.isAuthenticated()
  }

  async isAuthenticated () {
    try {
      const resp = await fetch(`${this.baseUrl}/alive`, {
        credentials: 'include'
      })
      return resp.ok
    } catch {
      return false
    }
  }

  async clearSession () {
    // 对于 HttpOnly Cookie，客户端删除无效，但可尝试清理非 HttpOnly 的兜底
    this._deleteCookie(this.cookieName)

    // 重点：调用服务端登出以销毁 HttpOnly 会话
    await fetch(`${this.baseUrl}/logout`, {
      method: 'POST',
      credentials: 'include'
    })
    // 如果需要可在此处检查返回结果，或者直接认为已登出
  }

  _deleteCookie (name, path = '/') {
    if (typeof document === 'undefined') return // 防止非浏览器环境报错
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`
  }
}

export default RttysAuth
